__turbopack_context__.v({
  "blog-link": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__blog-link",
  "blog-links": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__blog-links",
  "blog-links-list": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__blog-links-list",
  "featured-section": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__featured-section",
  "featured-sections": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__featured-sections",
  "grid": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__grid",
  "input": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__input",
  "left-column": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__left-column",
  "main": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__main",
  "results-count": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__results-count",
  "right-column": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__right-column",
  "search-form": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__search-form",
  "section": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__section",
  "section-empty": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__section-empty",
  "section-header": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__section-header",
  "section-meta": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__section-meta",
  "section-title": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__section-title",
  "sections": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__sections",
  "select": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__select",
  "sort-control": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__sort-control",
  "submit-button": "CoreNewsInsightsSearch-module-scss-module__ypgZTq__submit-button",
});
